import React, { useState, useEffect } from 'react';

function AddTaskModal({ isOpen, onClose, onAddTask, etapas, responsaveis }) {
  const [text, setText] = useState('');
  const [etapaId, setEtapaId] = useState('');
  const [prioridade, setPrioridade] = useState('Média');
  const [responsavel, setResponsavel] = useState('');
  const [dataInicio, setDataInicio] = useState('');
  const [dataFim, setDataFim] = useState('');

  useEffect(() => {
    if (isOpen) {
      if (etapas.length > 0 && !etapaId) {
        setEtapaId(etapas[0].id);
      }
    }
  }, [isOpen, etapas, etapaId]);

  if (!isOpen) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    // Apenas 'text' e 'etapaId' são obrigatórios
    if (!text || !etapaId) {
      alert('Por favor, preencha a Descrição da Tarefa e a Etapa.');
      return;
    }

    const newTask = {
      id: Date.now(),
      text,
      status: 'Não iniciado',
      prioridade,
      dataInicio,
      dataFim,
      dataConclusao: null,
      responsavel,
      membros: '' // Deixamos o campo, mas vazio, para não dar erro
    };
    onAddTask(etapaId, newTask);

    // Reseta todos os campos
    setText('');
    setEtapaId(etapas.length > 0 ? etapas[0].id : '');
    setPrioridade('Média');
    setResponsavel('');
    setDataInicio('');
    setDataFim('');
    onClose();
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h2>Adicionar Nova Tarefa</h2>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Descrição da Tarefa</label>
            <input type="text" value={text} onChange={(e) => setText(e.target.value)} required autoFocus />
          </div>
          <div className="form-group">
            <label>Etapa</label>
            <select value={etapaId} onChange={(e) => setEtapaId(e.target.value)} required>
              {etapas.map(etapa => (
                <option key={etapa.id} value={etapa.id}>{etapa.text}</option>
              ))}
            </select>
          </div>
          <div className="form-group-row">
            <div className="form-group">
              <label>Prioridade</label>
              <select value={prioridade} onChange={(e) => setPrioridade(e.target.value)}>
                <option value="Baixa">Baixa</option>
                <option value="Média">Média</option>
                <option value="Alta">Alta</option>
                <option value="Crítico">Crítico</option>
              </select>
            </div>
            <div className="form-group">
              <label>Responsável</label>
              <select value={responsavel} onChange={(e) => setResponsavel(e.target.value)}>
                <option value="">Selecione...</option>
                {responsaveis.map(r => <option key={r.id} value={r.name}>{r.name}</option>)}
              </select>
            </div>
          </div>
          <div className="form-group-row">
            <div className="form-group">
              <label>Data de Início</label>
              <input type="date" value={dataInicio} onChange={(e) => setDataInicio(e.target.value)} />
            </div>
            <div className="form-group">
              <label>Data Fim</label>
              <input type="date" value={dataFim} onChange={(e) => setDataFim(e.target.value)} />
            </div>
          </div>

          {/* O campo de Membros e o checkbox de Validação foram removidos */}

          <div className="modal-actions">
            <button type="button" onClick={onClose} className="btn-cancel">Cancelar</button>
            <button type="submit" className="btn-save">Salvar Tarefa</button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default AddTaskModal;